const getFontSize = (characterCount) => {
  if (characterCount < 120) {
    return 28;
  }
  if (characterCount >= 120 && characterCount < 200) {
    return 24;
  }
  if (characterCount >= 200 && characterCount <= 400) {
    return 22;
  }
  return 18;
};

export default getFontSize;
